import { createSelector } from 'reselect';
import { DataState } from '../state';

export const IsVirtualEnvironment = createSelector(
  (s: DataState) => s.environment.isVirtual,
  isVirtual => {
    return isVirtual;
  }
);
